export default {
    text: {
        title: 'Texto',
        addText: 'Novo texto',
        fontFamily: 'Família de fontes',
        fontSize: 'Font size',
        textAlignment: 'Alinhamento de texto',
        fontColor: 'Cor da fonte',
        lineSpacing: 'espaçamento entre linhas',
        arialSerif: 'Arial (sem serifa)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sem serifa)',
        trebuchetMSSansSerif: 'Trebuchet MS (sem serifa)',
        timesNewRomanSerif: 'Times New Roman (com serifa)',
        georgiaSerif: 'Georgia (serif)',
        garamondSerif: ' Garamond (com serifa)',
        courierNewMonospace: 'Courier New (monoespaçado)',
        brushScriptMTCursive: 'Pincel Script MT (cursiva)',
        backgroundColor: 'Cor de fundo',
    },
};
